import React from 'react';
import { gql } from '@apollo/client';
import { Form, Input, Select, DatePicker, Row, Col } from 'antd';
import { useMutation } from 'hooks/apollo';
import DrawerForm from 'components/DrawerForm';
import NumberInput from 'components/NumberInput';
import { DiscountType } from 'shared/prisma/types';
import { dayjs } from 'shared/utils/date';

const UPDATE_COUPON = gql`
  mutation UpdateCoupon($id: ID!, $input: CouponInput!) {
    updateCoupon(id: $id, input: $input) {
      id
      code
      description
      discountAmount
      discountType
      expirationDate
    }
  }
`;

const CREATE_COUPON = gql`
  mutation CreateCoupon($input: CouponInput!) {
    createCoupon(input: $input) {
      id
      code
      description
      discountAmount
      discountType
      expirationDate
    }
  }
`;

const EditCouponDrawer = ({ coupon, onDone, onUpdate }) => {
  const [updateCoupon] = useMutation(UPDATE_COUPON);
  const [createCoupon] = useMutation(CREATE_COUPON);

  const onSubmit = async (values) => {
    const input = {
      ...values,
      expirationDate: values.expirationDate ? values.expirationDate.toISOString() : null,
    };

    if (coupon.id) {
      await updateCoupon({ variables: { id: coupon.id, input } });
    } else {
      await createCoupon({ variables: { input } });
    }
    onUpdate();
  };

  const initialValues = coupon ? {
    ...coupon,
    expirationDate: coupon.expirationDate ? dayjs(coupon.expirationDate) : null,
  } : {};

  return (
    <DrawerForm
      title={coupon?.id ? 'Edit Coupon' : 'Create Coupon'}
      open={!!coupon}
      onCancel={onDone}
      onDone={onDone}
      onSubmit={onSubmit}
      initialValues={initialValues}
    >
      <Form.Item name="code" label="Code" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="description" label="Description">
        <Input.TextArea />
      </Form.Item>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item name="discountAmount" label="Discount Amount" rules={[{ required: true }]}>
            <NumberInput />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item name="discountType" label="Discount Type" rules={[{ required: true }]}>
            <Select options={Object.values(DiscountType).map(t => ({ label: t, value: t }))} />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item name="expirationDate" label="Expiration Date">
        <DatePicker style={{ width: '100%' }} />
      </Form.Item>
      <Form.Item name="limitPerCustomer" label="Usage limit per account">
        <NumberInput />
      </Form.Item>
    </DrawerForm>
  );
};

export default EditCouponDrawer;
